import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Link } from 'react-router-dom';

import design1 from './images/design1.png';
import design2 from './images/design2.png';
import design3 from './images/design3.png'
import design4 from './images/design4.png'
import design5 from './images/design5.png'
import design6 from './images/design6.png'
import design7 from './images/design7.png'
import design8 from './images/design8.png'
import design9 from './images/design9.png'
import design10 from './images/design10.png'
import design11 from './images/design11.png'
import design12 from './images/design12.png'
import Hellbirds from './images/Hellbirds.png'

//import character_design_1 from './images/character_design_1.png'
import './index.scss';
import { ImageGallery } from "./ImageGallery";

import {ImageGrid} from './ImageGrid'

// const images = [
//     {
//         original: design1,
//         thumbnail: design1,
//     },
//     {
//         original: design2,
//         thumbnail: design2,
//     },
// 
// 
// ];

// const imgs = [
//     {
//         src: design1,
//         width: design1.width,
//         height: design1.height
//     },
//     {
//         src: design2,
//         width: design2.width,
//         height: design2.height
//     },
//     {
//         src: design1,
//         width: design1.width,
//         height: design1.height
//     }
// ]

/*
const imgs = [
    
    {
        src: design1,
        width: 1685,
        height: 1148
    },
      
         
    {
        src: design2,
        width: 1731,
        height: 1129
    },
     {
        src: design3,
        width: 1731,
        height: 1129
    },
     {
        src: design4,
        width: 1731,
        height: 1129
    },

     {
        src: design5,
        width: 1731,
        height: 1129
    },
      {
        src: design6,
        width: 1731,
        height: 1129
    },

      {
        src: design7,
        width: 1731,
        height: 1129
    },
      {
        src: design8,
        width: 1731,
        height: 1129
    },

    {
        src: design9,
        width: 9899,
        height: 3555
    },
    {
        src: design10,
        width: 6388,
        height: 4221
    },

    {
        src: design11,
        width: 3200,
        height: 1782
    },


]


function Main() {
    return (
        <main className="page-CharacterDesign" >
            
            <div className= "character-image-gallery-block">
                <ImageGallery  photos={imgs} />
            </div>
        </main>
    );
}

export default Main;

*/

const GridWithImageLinks = () => {
  const items = [
    { id: 1, title: "Visual development", imageUrl: design1, link: "/visdev" },
    { id: 2, title: "Demo Reel", imageUrl: design2, link: "/demo-reel" },
    { id: 3, title: "Illustration", imageUrl: design12, link: "/illustration" },
    { id: 4, title: "Production Work", imageUrl: design6, link: "/ndawork" }
  ];
  const [hoveredId, setHoveredId] = useState(null);

  return (
    <div className="container-fluid" style={{ maxWidth: '85vw', padding: '2rem' }}>
      <div className="row row-cols-1 row-cols-md-2 g-4">
        {items.map(item => (
          <div key={item.id} className="col">
            <Link
              to={item.link}
              className="d-block position-relative overflow-hidden"
              onMouseEnter={() => setHoveredId(item.id)}
              onMouseLeave={() => setHoveredId(null)}
            >
              <img
                src={item.imageUrl}
                className="img-fluid w-100"
                alt={item.title}
                style={{
                  objectFit: 'cover',
                  height: '450px',  // Landscape height

                  transition: 'opacity 0.1s ease-in-out',
                  opacity: hoveredId === item.id ? 0.7 : 1
                }}
              />
              <div
                className="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
                style={{
                  background: 'rgba(255, 255, 255, 0.7)',
                  opacity: hoveredId === item.id ? 1 : 0,
                  transition: 'opacity 0.1s ease-in-out'

                }}
              >
                <h3 className="text-grey">{item.title}</h3>
              </div>
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
};

export default GridWithImageLinks;

